module.exports = __webpack_public_path__ + "media/videos/new_welcome_video-db2d2edb5a717a365d025fecf09a390f.mov";